import { CREATE_GENERAL, GET_ALL_GENERAL, GET_ALL_LANGUAGE,GET_ALL_REPORT_REMINDER, GET_ALL_SUBSCRIBE_CASES } from '../types'

const INITIAL_STATE = {
  allGeneral: [],
  addGeneral: [],
  allLanguage: [],
  allReportReminder: [],
  subscriptionDetails: [],
}

const generalReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case CREATE_GENERAL:
      return {
        ...state,
        addGeneral: payload.data,
      }
    case GET_ALL_GENERAL:
      return {
        ...state,
        allGeneral: payload.data,
      }
    case GET_ALL_LANGUAGE:
      return {
        ...state,
        allLanguage: payload.data,
      }
    case GET_ALL_REPORT_REMINDER:
        return {  
          ...state,
          allReportReminder: payload.data,
        }
    case GET_ALL_SUBSCRIBE_CASES:
        return {  
          ...state,
          subscriptionDetails: payload.data,
        }
    default:
      return state
  }
}

export default generalReducer
